import { IconButton, Tooltip, useTheme } from '@mui/material'

import { BiEdit, BiShow, BiTrash } from 'react-icons/bi'
import { TbLock } from 'react-icons/tb'
import { useConfirm } from '../../Confirm/CoreConfirm'
import { useTranslation } from 'react-i18next'
import { MdOutlineFactCheck } from 'react-icons/md'
import { ContentCopy } from '@mui/icons-material'
import { successMsg } from '@Core/Helpers/Message'
/*
 * Created Date: 04-09-2022, 9:42:53 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

export const CoreActionCopy = ({ content, titleTooltip }) => {
	const { t } = useTranslation()
	const handleClick = () => {
		navigator.clipboard.writeText(content)
		successMsg(t('Đã sao chép'))
	}
	return <CoreActionIcon icon={<ContentCopy />} titleTooltip={t(titleTooltip ?? 'Sao chép')} onClick={handleClick} />
}

export const CoreActionIcon = ({
	onClick = () => {},
	disabled = false,
	titleTooltip,
	icon,
	color = 'primary',
	className
}) => {
	const { t } = useTranslation('common')
	if (disabled) {
		return (
			<IconButton disabled className="text-sm" color={color}>
				{icon}
			</IconButton>
		)
	}
	return (
		<Tooltip title={titleTooltip}>
			<IconButton
				onClick={onClick}
				size="small"
				className="text-sm"
				color={color}
				sx={{ minWidth: 40, minHeight: 40 }}
			>
				{icon}
			</IconButton>
		</Tooltip>
	)
}

export const CoreActionEdit = ({ onClick = () => {}, disabled = false, titleTooltip }) => {
	const { t } = useTranslation('common')
	if (disabled) {
		return (
			<IconButton disabled className="text-sm" color="primary">
				<BiEdit />
			</IconButton>
		)
	}
	return (
		<Tooltip title={titleTooltip ?? t('Edit')}>
			<IconButton onClick={onClick} className="text-sm" color="primary">
				<BiEdit />
			</IconButton>
		</Tooltip>
	)
}

export const CoreActionBlock = ({ onConfirmBlock = () => {}, disabled = false }) => {
	const { t } = useTranslation('common')
	const confirm = useConfirm()

	const handleClickBlock = () => {
		confirm({
			content: t('table.block_confirm'),
			// color: 'error',
			onOk: onConfirmBlock,
			zIndex: 9999,
			icon: 'block'
		})
	}
	if (disabled) {
		return (
			<IconButton disabled className="text-sm" color="primary">
				<TbLock />
			</IconButton>
		)
	}
	return (
		<Tooltip title={t('btn.block')}>
			<IconButton onClick={handleClickBlock} className="text-sm" color="error">
				<TbLock />
			</IconButton>
		</Tooltip>
	)
}

export const CoreActionView = ({ onClick = () => {}, title = null, placement }) => {
	const { t } = useTranslation('common')
	const theme = useTheme()
	return (
		<Tooltip title={title ?? t('Chi tiết')} placement={placement}>
			<IconButton style={{ color: theme.palette.success.main }} onClick={onClick}>
				<BiShow />
			</IconButton>
		</Tooltip>
	)
}

export const CoreActionResult = ({ onClick = () => {}, title = null, placement }) => {
	const { t } = useTranslation('common')
	const theme = useTheme()
	return (
		<Tooltip title={title ?? t('Kết quả ôn thi')} placement={placement}>
			<IconButton style={{ color: theme.palette.success.main }} onClick={onClick}>
				<MdOutlineFactCheck />
			</IconButton>
		</Tooltip>
	)
}

export const CoreActionDelete = ({
	onConfirmDelete = () => {},
	disabled = false,
	content = 'Bạn có muốn xoá dữ liệu này không?',
	title,
	titleTooltip
}) => {
	const { t } = useTranslation('common')

	const confirm = useConfirm()

	const handleClickDelete = () => {
		confirm({
			title,
			content,
			color: 'error',
			onOk: onConfirmDelete,
			zIndex: 9999
		})
	}

	if (disabled) {
		return (
			<IconButton color="error" disabled={disabled}>
				<BiTrash />
			</IconButton>
		)
	}
	return (
		<Tooltip title={titleTooltip ?? t('Delete')}>
			<IconButton onClick={handleClickDelete} color="error">
				<BiTrash />
			</IconButton>
		</Tooltip>
	)
}
